/*
 * @Author: Kaiser
 * @Date: 2019-07-25 14:20:05
 * @Last Modified by: Kaiser
 * @Last Modified time: 2019-08-02 10:04:21
 * @Description: 异步引入方法
 */
var asyncImport = function (file) { return function () { return import("@/pages" + file); }; };
export default asyncImport;
